import throttle from "raf-throttle";

export const topbar = function (el) {
    function updatePosition() {
        let scrollPosition = window.pageYOffset;
        const treshold = Math.round(window.innerHeight / 10);
        if (
            scrollPosition >= treshold &&
            !document.body.classList.contains("body--topbar-fixed")
        ) {
            document.body.classList.add("body--topbar-fixed");
        } else if (
            scrollPosition < treshold &&
            document.body.classList.contains("body--topbar-fixed")
        ) {
            document.body.classList.remove("body--topbar-fixed");
        }
    }

    const throttled = throttle(updatePosition);

    window.addEventListener("scroll", throttled);
};
